<template>
    <div class="upload-panel-wrapper col-md-5 p-0">
        <div class="close-or-min-panel">
            <div class="heading">{{$t('BINS')}}</div>
            <div class="close-icon-wrapper">
                <cancel-icon @click.native="closePanel" class="close-icon mt-1"></cancel-icon>
            </div>
        </div>
        <div class="info-wrapper">
            <div class="normal-text-display">{{$t('Bin is a named storage entity')}}.</div>
            <div class="normal-text-display">{{$t('Simple example is CIFS/SMB Shared folder can treated as Bin. Another example includes FTP server')}}.</div>
            <div class="normal-text-display">
                <div class="sub-header-wrapper"><b class="sub-header">{{$t('Based on nature of storage content bins are classified as 4 types')}}</b></div>
                <div class="text-with-bullets-wrapper"><div class="bullets-wrapper"><div class="bullets">1</div></div><div class="text-for-bullet">{{$t('Asset bins: Day today usage content is stored on this bin type')}}</div></div>
                <div class="text-with-bullets-wrapper"><div class="bullets-wrapper"><div class="bullets">2</div></div><div class="text-for-bullet">{{$t('Archive Bins: Archive content which is kept for future usage will be stored on bin type')}}</div></div>
                <div class="text-with-bullets-wrapper"><div class="bullets-wrapper"><div class="bullets">3</div></div><div class="text-for-bullet">{{$t('Proxy: Media thumbnails and proxy are stored on this bin type')}}</div></div>
                <div class="text-with-bullets-wrapper"><div class="bullets-wrapper"><div class="bullets">4</div></div><div class="text-for-bullet">{{$t('Target: To send media to external FTP server are considered as Target bin type')}}</div></div>
            </div>

            <div class="normal-text-display">{{$t('Bins needs to have interface to push and pull content')}}.</div>
            <div class="normal-text-display" style="display:grid">
                <div class="sub-header-wrapper"><b class="sub-header">{{$t('This interface is represented as Bin Protocol. Bin protocols are')}}</b></div>
                <div class="text-with-bullets-wrapper"><div class="bullets-wrapper"><div class="bullets">1</div></div><div class="text-for-bullet">CIFS</div></div>
                <div class="text-with-bullets-wrapper"><div class="bullets-wrapper"><div class="bullets">2</div></div><div class="text-for-bullet">FTP</div></div>
                <div class="text-with-bullets-wrapper"><div class="bullets-wrapper"><div class="bullets">3</div></div><div class="text-for-bullet">AWS</div></div>
            </div>
            <div class="normal-text-display">{{$t('To get content inside Bins user can enable watch folder. Any thing placed on watch folder will be ingested into application')}}.</div>
        </div>
    </div>
</template>

<script>
import cancelIcon from "../core/InlineCancelField.vue"
export default {
    components:{
        'cancel-icon':cancelIcon,
    },
    methods:{
        closePanel(){
            this.$emit("close");
        },
    },
}
</script>

<style scoped lang="scss">
$dull-text-color: #858585;
$active-green-color:#28a745;
$overlay-info-panel-bg-color:#1b1b1b;
$overlay-panel-border-color:#272727;
$panel-heading-font-size:24px;
$info-color:rgb(209, 210, 211);
$info-font-size:15px;
$info-sub-header-color:#e8912d;
$info-header-font-size:22px;
$tip-border-color:#23485f;
$tip-background-color:#10202a;
$tip-text-color:#8aa1ad;
$tip-icon-color:#85b5ce;
$bullet-background-color:#295318;
$close-icon-bg-on-hover:#3a3a3a;
$border-color: 1px solid #4a4a4a;
$border-color-only:#4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$danger-color: #dc3545 !important;
$input-field-height:38px;
$none-text-color:#4f4f4f;
$input-field-padding:.375rem 10px;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555;
$tags-background-color:#282d31;
$button-height:38px;
$tags-border-color:#363636;
$metadata-border-color-on-hover: #5a5a5a;
$secondary-border-color: 1px solid #2b2b2b;
$active-green-color:#28a745;
$svg-color:#666;
$learn-about-text-color-hover:#b7b327;
$active-green-icon-color: #00ff3a;
$learn-about-text-color:#9a9620;
$icon-hover:#2c3339;

.active{
    color:$active-blue;
}

/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $scrollbar-track-background;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $scrollbar-thumb-on-hover-background;
}

.filters-bar{
    max-height: 100%;
    width: 100%;
    overflow:auto;
    display:inline-block;
    ul{
        list-style-type: none;
        padding-inline-start:2px;
        li{
            text-align: start;
            margin-inline-start: 6%;
            margin-top: 9px;
        }
    }
}
.upload-panel-wrapper{
    border-inline-start: $secondary-border-color;
    position: absolute;
    background: $primary-background;
    bottom: 1px!important;
    top: 2px !important;
    inset-inline-end: 0%;
    z-index: 9;
    max-height: 100%;
    height: 100%;
    box-shadow: 1px 2px 32px 4px rgba(0,0,0,0.63);
    -webkit-box-shadow: 1px 2px 32px 4px rgba(0,0,0,0.63);
    -moz-box-shadow: 1px 2px 32px 4px rgba(0,0,0,0.63);
    .close-or-min-panel{
            height: 60px;
            width:100%;
            border-bottom: $secondary-border-color;
            background: $secondary-background-color;
            text-align: end;
            padding: 12px;
            display: flex;
            justify-content: flex-end;
        }
    .info-wrapper{
            width: 100%;
            padding: 24px;
            overflow:auto;
            display:inline-block;
            height: 90%;
            .edit-upload-info{
                width:8%;
                padding: 5px;
                    svg{
                        position: relative;
                        inset-inline-end: 6px;
                    }
            }
            }
        }



.edit-upload-info{
    position: relative;
    inset-inline-start:0px;
}

.minHeight{
    height:52px !important;
    bottom:1px !important;
    top: unset !important;
}

.upload-bars{
    margin-bottom: 12px;
}

.heading{
    text-align:start;
    width:94%;
    padding:2px;
    font-size:$panel-heading-font-size;
}

.normal-text-display{
    text-align: start;
    margin-bottom: 10px;
    color:$info-color;
    font-size:$info-font-size;
}

.sub-header{
    color: $info-sub-header-color;
    font-weight: 100;
    font-size:$info-header-font-size
}

.sub-header-wrapper{
    margin:25px 0px 5px 0px;
}

.tip-div{
    width: 100%;
    height: auto;
    display:inline-flex;
    padding: 12px;
    text-align: start;
    border: 1px solid $tip-border-color;
    background: $tip-background-color;
    border-radius: 5px;
    margin: 20px 0;
    color: $tip-text-color;
    svg{
        margin: 0px 14px 0px 0px;
        color: $tip-icon-color;
    }
}

.text-with-bullets-wrapper{
    display:inline-flex;
    margin-bottom: 10px;
    .bullets-wrapper{
        .bullets{
            height: 23px;
            width: 23px;
            border-radius: 8px;
            background: $bullet-background-color;
            margin: 0 auto;
            padding-inline-start: 7px;
            padding-top: 1px;
            margin: 3px 14px 0px 5px;
        }
    }
    .text-for-bullet{
        padding-top:4px;
    }
}

.image-wrapper{
    height: auto;
    width: 250px;
    margin: 20px auto;
}

.close-icon-wrapper{
    position: relative;
    bottom: 1px;
    .close-icon{
        height: 30px !important;
        width: 30px !important;
        color: $dull-text-color !important;
    }
}

.close-icon:hover{
  background: $icon-hover;
  border-radius: 20px;
}
</style>



